import React from 'react'
import HomePortfolio from '../components/HomeSections/HomePortfolio'
import HomeContact from '../components/HomeSections/HomeContact'

const Portfolio = () => {
  return (
    <div className='pt-5 mt-4'>
      <HomePortfolio />
      <HomeContact />
    </div>
  )
}

export default Portfolio
